// Library Imports
import React, { useContext } from 'react'
import { Skeleton } from '@mui/material';
import { Form } from 'react-bootstrap';
import * as RiIcons from 'react-icons/ri'
// Context Imports
import { DirectoryContext } from '../../contexts/DirectoryContext';
// Asset Imports
import '../../assets/css/stylesheets/components/search/CategoryDropDown.css'

function CategoryDropDown({ selectedValue, onCategoryChanged }) {

    // Get state option values from the context
    const {
        isCategoriesLoaded,
        isSubCategoriesLoaded,
        categoryOptions,
        subCategoryOptions,
    } = useContext(DirectoryContext)

    return (
        <>
            {
                !isCategoriesLoaded && !isSubCategoriesLoaded ?
                    <Skeleton
                        sx={{ bgcolor: 'grey.200', opacity: '75%', borderRadius: '4%', margin: '1rem' }}
                        variant='rectangular'
                        animation="wave"
                        width={300}
                        height={45} />
                    :
                    <div className='categorydropdown'>
                        <RiIcons.RiStackLine className='categorydropdown-icon' />
                        <Form.Select
                            className='categorydropdown-control'
                            id='listingSearchCategory'
                            value={selectedValue}
                            onChange={onCategoryChanged}>
                            <option>Select Category</option>
                            {
                                categoryOptions.map((category) => {
                                    var options = [];
                                    options.push(<option disabled value="">{category.Name}</option>);

                                    subCategoryOptions?.filter(sub => sub.CategoryID == category.ID).map((subcategory) => {
                                        options.push(<option value={subcategory.ID}>&nbsp;{subcategory.Name}</option>);
                                    })
                                    return (options)
                                })
                            }
                        </Form.Select>
                    </div>
            }
        </>
    )
}

export default CategoryDropDown